import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly darkModeSubject = new BehaviorSubject<boolean>(false);
  readonly darkMode$ = this.darkModeSubject.asObservable();

  private readonly navCollapsedSubject = new BehaviorSubject<boolean>(false);
  readonly navCollapsed$ = this.navCollapsedSubject.asObservable();

  setDarkMode(darkMode: boolean): void {
    this.darkModeSubject.next(darkMode);

    const element = document.querySelector('html');
    if (darkMode) {
      element?.classList.add('p-dark');
    } else {
      element?.classList.remove('p-dark');
    }
  }

  toggleDarkMode(): void {
    this.setDarkMode(!this.getDarkMode());
  }

  getDarkMode(): boolean {
    return false;
    // return this.darkModeSubject.getValue();
  }

  setNavCollapsed(navCollapsed: boolean): void {
    this.navCollapsedSubject.next(navCollapsed);
  }

  getIsNavCollapsed(): boolean {
    return this.navCollapsedSubject.getValue();
  }

  toggleNavCollapsed(): void {
    this.setNavCollapsed(!this.getIsNavCollapsed());
  }
}
